<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="{ ...attrs, ...$attrs }" v-on="on">
        <v-icon v-text="icon" left></v-icon>
        {{ label }}
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click="handleChangeVisibility(true)">
        <v-list-item-icon>
          <v-icon>mdi-eye</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title> {{ __("dar visibilidade") }} </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="handleChangeVisibility(false)">
        <v-list-item-icon>
          <v-icon>mdi-eye-off</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ __("remover visibilidade") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import i18n from "@/mixins/i18n";

export default {
  mixins: [i18n],

  components: {},

  props: {
    icon: String,
    label: String,
  },

  data() {
    return {
      i18n_prefix: "documents",
    };
  },

  methods: {
    handleChangeVisibility(visibility) {
      this.$emit("change_visibility", visibility);
    },
  },

  computed: {},
};
</script>
